module.exports = __webpack_public_path__ + "img/doc.61a14418.svg";